/// <reference path="DOMAttached.js" />

class Animation extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		this.nextFrame = 1;
		this.increment = 1;
		this.timer = null;

		// fade effect
		this.timer = setInterval(this.fadeIn.bind(this), 100);

		// animation
		setInterval(
			function() {
				var posX = this.nextFrame * this.options.width;
				this.el.style.backgroundPosition = "-" + posX + "px 0px";
				this.nextFrame += this.increment;
				if (this.nextFrame >= this.options.tilecount || this.nextFrame < 0) {
					if (this.options.rewind) {
						this.increment = -this.increment;
						this.nextFrame += this.increment;
					} else {
						this.nextFrame = 0;
					}
				}
			}.bind(this),
			this.options.speed
		);
	}

	fadeIn() {
		if (this.el.querySelector(".hiddenimg").complete) {
			this.el.style.visibility = "visible";
			clearInterval(this.timer);
		}
	}
}
